var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('operation-template',{attrs:{"id":_vm.$route.params.id||0,"changeTemplate":true},on:{"success":function($event){return _vm.goBack()},"cancel":function($event){return _vm.goBack()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }